<template>
  <div class="container">
    <div class="columns">
      <div class="column has-text-left">
        <div class="columns is-mobile">
          <div class="column is-1">
            <b-tooltip type="is-dark" position="is-right" :label="$translate('copy_dx_in_sx') | capitalize" multilined>
              <a class="button is-primary" :disabled="order.pair !== 'both' || disabledbool" @click="copypasdxinsx()">
                <b-icon icon="content-copy" />
              </a>
            </b-tooltip>
          </div>
          <div class="column is-11">
            <h3 class="subtitle green">
              {{ $translate('left_foot') | uppercase }}
            </h3>
          </div>
        </div>
      </div>
      <div class="column has-text-right">
        <div class="columns is-mobile">
          <div class="column is-11">
            <h3 class="subtitle green">
              {{ $translate('right_foot') | uppercase }}
            </h3>
          </div>
          <div class="column is-1">
            <b-tooltip type="is-dark" position="is-left" :label="$translate('copy_sx_in_dx') | capitalize" multilined>
              <a class="button is-primary" :disabled="order.pair !== 'both' || disabledbool" @click="copypassxindx()">
                <b-icon icon="content-copy" />
              </a>
            </b-tooltip>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <img class="preview" :src="contrSxPreview" />
      </div>
      <div class="column is-6">
        <table v-if="order.module === 'fits'" class="bordered-table static">
          <tr>
            <td />
            <td>
              <h3 class="subtitle green has-text-centered has-text-weight-bold">
                {{ $translate('PaS') | uppercase }}
              </h3>
            </td>
            <td />
          </tr>
          <tr>
            <td />
            <td>
              <hr class="green" />
            </td>
            <td />
          </tr>
          <tr>
            <td class="has-text-centered">
              <b-field :type="{ 'is-danger': errors.has('typecontr_sx') }" :message="errors.first('typecontr_sx')">
                <b-select
                  v-model="order['typecontr_sx']"
                  v-validate="{ required: order.deliverySelected != 'onlytom' }"
                  :disabled="order.pair === 'right' || disabledbool"
                  name="typecontr_sx"
                  :placeholder="$translate('placeholder_select')"
                >
                  <option v-for="(t, i) in config.getOrderContraffortiType(order.shoeType)" :key="i" :value="t">{{
                    $translate(t) | capitalize
                  }}</option>
                </b-select>
              </b-field>
            </td>
            <td class="has-text-centered">
              {{ $translate('type') | capitalize }}
            </td>
            <td class="has-text-centered">
              <b-field :type="{ 'is-danger': errors.has('typecontr_dx') }" :message="errors.first('typecontr_dx')">
                <b-select
                  v-model="order['typecontr_dx']"
                  v-validate="{ required: order.deliverySelected != 'onlytom' }"
                  :disabled="order.pair === 'left' || disabledbool"
                  :name="'typecontr_dx'"
                  :placeholder="$translate('placeholder_select')"
                >
                  <option v-for="(t, i) in config.getOrderContraffortiType(order.shoeType)" :key="i" :value="t">{{
                    $translate(t) | capitalize
                  }}</option>
                </b-select>
              </b-field>
            </td>
          </tr>
          <tr>
            <td class="has-text-centered">
              <b-field
                v-if="order['typecontr_sx'] && order['typecontr_sx'] != 'Noone'"
                :type="{ 'is-danger': errors.has('tipocontr_sx') }"
                :message="errors.first('tipocontr_sx')"
              >
                <b-select
                  v-model="order['tipocontr_sx']"
                  v-validate="{ required: order.deliverySelected != 'onlytom' }"
                  :disabled="order.pair === 'right' || disabledbool"
                  :name="'tipocontr_sx'"
                  :placeholder="$translate('placeholder_select')"
                  @input="changeContrMaterialSx"
                >
                  <option v-for="variant in availablecont" :key="variant.id + '_sx'" :value="variant.id">
                    {{ $translateMaterial(variant) }}
                  </option>
                </b-select>
              </b-field>
            </td>
            <td class="has-text-centered">
              {{ $translate('matcontra') | capitalize }}
            </td>
            <td class="has-text-centered">
              <b-field
                v-if="order['typecontr_dx'] && order['typecontr_dx'] != 'Noone'"
                :type="{ 'is-danger': errors.has('tipocontr_dx') }"
                :message="errors.first('tipocontr_dx')"
              >
                <b-select
                  v-model="order['tipocontr_dx']"
                  v-validate="{ required: order.deliverySelected != 'onlytom' }"
                  :disabled="order.pair === 'left' || disabledbool"
                  :name="'tipocontr_dx'"
                  :placeholder="$translate('placeholder_select')"
                  @input="order['tipocontr_var_dx'] = null"
                >
                  <option v-for="variant in availablecont" :key="variant.id + '_dx'" :value="variant.id">
                    {{ $translateMaterial(variant) }}
                  </option>
                </b-select>
              </b-field>
            </td>
          </tr>
          <tr>
            <td
              v-if="
                order['tipocontr_sx'] &&
                  availablecont.find(temp => temp.id === order['tipocontr_sx']) &&
                  availablecont.find(temp => temp.id === order['tipocontr_sx']).variants
              "
              class="has-text-centered"
            >
              <b-field
                v-if="order['typecontr_sx'] && order['typecontr_sx'] != 'Noone'"
                :type="{ 'is-danger': errors.has('tipocontr_var_sx') }"
                :message="errors.first('tipocontr_var_sx')"
              >
                <b-select
                  v-model="order['tipocontr_var_sx']"
                  v-validate="{ required: order.deliverySelected != 'onlytom' }"
                  :disabled="order.pair === 'right' || disabledbool"
                  :name="'tipocontr_var_sx'"
                  :placeholder="$translate('placeholder_select')"
                >
                  <option
                    v-for="variant in availablecont.find(temp => temp.id === order['tipocontr_sx']).variants"
                    :key="variant.id"
                    :value="variant.id"
                  >
                    {{ $translateMaterialVariant(variant) }}
                  </option>
                </b-select>
              </b-field>
            </td>
            <td v-else-if="order['tipocontr_dx']" class="has-text-centered" />
            <td v-if="order['tipocontr_sx'] || order['tipocontr_dx']" class="has-text-centered">
              {{ $translate('variant') | capitalize }}
            </td>
            <td
              v-if="
                order['tipocontr_dx'] &&
                  availablecont.find(temp => temp.id === order['tipocontr_dx']) &&
                  availablecont.find(temp => temp.id === order['tipocontr_dx']).variants
              "
              class="has-text-centered"
            >
              <b-field
                v-if="order['typecontr_dx'] && order['typecontr_dx'] != 'Noone'"
                :type="{ 'is-danger': errors.has('tipocontr_var_dx') }"
                :message="errors.first('tipocontr_var_dx')"
              >
                <b-select
                  v-model="order['tipocontr_var_dx']"
                  v-validate="{ required: order.deliverySelected != 'onlytom' }"
                  :disabled="order.pair === 'left' || disabledbool"
                  :name="'tipocontr_var_dx'"
                  :placeholder="$translate('placeholder_select')"
                >
                  <option
                    v-for="variant in availablecont.find(temp => temp.id === order['tipocontr_dx']).variants"
                    :key="variant.id"
                    :value="variant.id"
                  >
                    {{ $translateMaterialVariant(variant) }}
                  </option>
                </b-select>
              </b-field>
            </td>
            <td v-else-if="order['tipocontr_sx']" class="has-text-centered" />
          </tr>
          <tr>
            <td class="has-text-centered">
              <b-select
                v-if="order['typecontr_sx'] && order['typecontr_sx'] != 'Noone'"
                v-model="order['tiporinfcontr_sx']"
                :disabled="order.pair === 'right' || disabledbool"
                :name="'tiporinfcontr_sx'"
                :placeholder="$translate('placeholder_select')"
              >
                <option value="Noone">
                  {{ $translate('Noone') | capitalize }}
                </option>
                <option value="total">
                  {{ $translate('total') | capitalize }}
                </option>
                <option value="only_base">
                  {{ $translate('only_base') | capitalize }}
                </option>
                <option value="only_post">
                  {{ $translate('only_post') | capitalize }}
                </option>
              </b-select>
            </td>
            <td class="has-text-centered">
              {{ $translate('rinfcontr') | capitalize }}
            </td>
            <td class="has-text-centered">
              <b-select
                v-if="order['typecontr_dx'] && order['typecontr_dx'] != 'Noone'"
                v-model="order['tiporinfcontr_dx']"
                :disabled="order.pair === 'left' || disabledbool"
                :name="'tiporinfcontr_dx'"
                :placeholder="$translate('placeholder_select')"
              >
                <option value="Noone">
                  {{ $translate('Noone') | capitalize }}
                </option>
                <option value="total">
                  {{ $translate('total') | capitalize }}
                </option>
                <option value="only_base">
                  {{ $translate('only_base') | capitalize }}
                </option>
                <option value="only_post">
                  {{ $translate('only_post') | capitalize }}
                </option>
              </b-select>
            </td>
          </tr>
          <!-- TODO: Capire come gestire i materiali di rinforzo, non avendo a disposizione i rinforzi nella sezione materiali fits -->
          <!-- <tr>
            <td class="has-text-centered">
              <b-select
                v-if="order['tiporinfcontr_sx'] && order['tiporinfcontr_sx'] != 'Noone'"
                v-model="order['matrinfcontr_sx']"
                :disabled="order.pair === 'right' || disabledbool"
                :name="'matrinfcontr_sx'"
                :placeholder="$translate('placeholder_select')"
                @input="
                  order['matrinfcontr_var_sx'] = null
                  $forceUpdate()
                "
              >
                <option v-for="variant in availablereinforcement" :key="variant.id + '_sx'" :value="variant.id">
                  {{ $translateMaterial(variant) }}
                </option>
              </b-select>
            </td>
            <td class="has-text-centered">
              {{ $translate('matrinfcontr') | capitalize }}
            </td>
            <td class="has-text-centered">
              <b-select
                v-if="order['tiporinfcontr_dx'] && order['tiporinfcontr_dx'] != 'Noone'"
                v-model="order['matrinfcontr_dx']"
                :disabled="order.pair === 'left' || disabledbool"
                :name="'matrinfcontr_dx'"
                :placeholder="$translate('placeholder_select')"
                @input="
                  order['matrinfcontr_var_dx'] = null
                  $forceUpdate()
                "
              >
                <option v-for="variant in availablereinforcement" :key="variant.id + '_dx'" :value="variant.id">
                  {{ $translateMaterial(variant) }}
                </option>
              </b-select>
            </td>
          </tr>-->
          <!--          <tr>
            <td
              v-if="
                order['matrinfcontr_sx'] &&
                  availablereinforcement.find(temp => temp.id === order['matrinfcontr_sx']) &&
                  availablereinforcement.find(temp => temp.id === order['matrinfcontr_sx']).variants
              "
              class="has-text-centered"
            >
              <b-field
                v-if="order['typecontr_sx'] && order['typecontr_sx'] != 'Noone'"
                :type="{ 'is-danger': errors.has('matrinfcontr_var_sx') }"
                :message="errors.first('matrinfcontr_var_sx')"
              >
                <b-select
                  v-model="order['matrinfcontr_var_sx']"
                  v-validate="{ required: order.deliverySelected != 'onlytom' }"
                  :disabled="order.pair === 'right' || disabledbool"
                  :name="'matrinfcontr_var_sx'"
                  :placeholder="$translate('placeholder_select')"
                >
                  <option
                    v-for="variant in availablereinforcement.find(temp => temp.id === order['matrinfcontr_sx'])
                      .variants"
                    :key="variant.id"
                    :value="variant.id"
                  >
                    {{ $translateMaterialVariant(variant) }}
                  </option>
                </b-select>
              </b-field>
            </td>
            <td v-else-if="order['matrinfcontr_dx']" class="has-text-centered" />
            <td v-if="order['matrinfcontr_sx'] || order['matrinfcontr_dx']" class="has-text-centered">
              {{ $translate('variant') | capitalize }}
            </td>
            <td
              v-if="
                order['matrinfcontr_dx'] &&
                  availablereinforcement.find(temp => temp.id === order['matrinfcontr_dx']) &&
                  availablereinforcement.find(temp => temp.id === order['matrinfcontr_dx']).variants
              "
              class="has-text-centered"
            >
              <b-field
                v-if="order['typecontr_dx'] && order['typecontr_dx'] != 'Noone'"
                :type="{ 'is-danger': errors.has('matrinfcontr_var_dx') }"
                :message="errors.first('matrinfcontr_var_dx')"
              >
                <b-select
                  v-model="order['matrinfcontr_var_dx']"
                  v-validate="{ required: order.deliverySelected != 'onlytom' }"
                  :disabled="order.pair === 'left' || disabledbool"
                  :name="'matrinfcontr_var_dx'"
                  :placeholder="$translate('placeholder_select')"
                >
                  <option
                    v-for="variant in availablereinforcement.find(temp => temp.id === order['matrinfcontr_dx'])
                      .variants"
                    :key="variant.id"
                    :value="variant.id"
                  >
                    {{ $translateMaterialVariant(variant) }}
                  </option>
                </b-select>
              </b-field>
            </td>
          </tr>-->
        </table>

        <table v-else-if="order.module === 'modular'" class="bordered-table static">
          <tr>
            <td />
            <td>
              <h3 class="subtitle green has-text-centered has-text-weight-bold">
                {{ $translate('PaS') | uppercase }}
              </h3>
            </td>
            <td />
          </tr>
          <tr>
            <td />
            <td>
              <hr class="green" />
            </td>
            <td />
          </tr>
          <tr>
            <td class="has-text-centered">
              <b-field :type="{ 'is-danger': errors.has('typecontr_sx') }" :message="errors.first('typecontr_sx')">
                <b-select
                  v-model="order['typecontr_sx']"
                  v-validate="{ required: order.deliverySelected != 'onlytom' }"
                  :disabled="order.pair === 'right' || disabledbool"
                  name="typecontr_sx"
                  :placeholder="$translate('placeholder_select')"
                >
                  <option
                    v-for="(t, i) in config.getOrderContraffortiType(order.shoeType, order.mod.hasForteAlto)"
                    :key="i"
                    :value="t"
                    >{{ $translate(t) | capitalize }}
                  </option>
                </b-select>
              </b-field>
            </td>
            <td class="has-text-centered">
              {{ $translate('type') | capitalize }}
            </td>
            <td class="has-text-centered">
              <b-field :type="{ 'is-danger': errors.has('typecontr_dx') }" :message="errors.first('typecontr_dx')">
                <b-select
                  v-model="order['typecontr_dx']"
                  v-validate="{ required: order.deliverySelected != 'onlytom' }"
                  :disabled="order.pair === 'left' || disabledbool"
                  :name="'typecontr_dx'"
                  :placeholder="$translate('placeholder_select')"
                >
                  <option
                    v-for="(t, i) in config.getOrderContraffortiType(order.shoeType, order.mod.hasForteAlto)"
                    :key="i"
                    :value="t"
                    >{{ $translate(t) | capitalize }}
                  </option>
                </b-select>
              </b-field>
            </td>
          </tr>
        </table>
      </div>
      <div class="column has-text-right">
        <img class="preview" :src="contrDxPreview" />
      </div>
    </div>
    <div v-if="sole && order.module === 'fits' ? sole.hasCorrections : true">
      <div class="columns">
        <div class="column has-text-left">
          <div class="columns is-mobile">
            <div class="column is-1">
              <b-tooltip
                type="is-dark"
                position="is-right"
                :label="$translate('copy_dx_in_sx') | capitalize"
                multilined
              >
                <a
                  class="button is-primary"
                  :disabled="order.pair !== 'both' || disabledbool"
                  @click="copyToOtherFoot('right', true)"
                >
                  <b-icon icon="content-copy" />
                </a>
              </b-tooltip>
            </div>
            <div class="column is-11">
              <h3 class="subtitle green">
                {{ $translate('left_foot') | uppercase }}
              </h3>
            </div>
          </div>
        </div>
        <div class="column has-text-right">
          <div class="columns is-mobile">
            <div class="column is-11">
              <h3 class="subtitle green">
                {{ $translate('right_foot') | uppercase }}
              </h3>
            </div>
            <div class="column is-1">
              <b-tooltip type="is-dark" position="is-left" :label="$translate('copy_sx_in_dx') | capitalize" multilined>
                <a
                  class="button is-primary"
                  :disabled="order.pair !== 'both' || disabledbool"
                  @click="copyToOtherFoot('left', true)"
                >
                  <b-icon icon="content-copy" />
                </a>
              </b-tooltip>
            </div>
          </div>
        </div>
      </div>

      <div class="columns">
        <div class="column" />
        <div class="column is-6">
          <table class="bordered-table static">
            <tr>
              <td />
              <td>
                <h3 class="subtitle green has-text-centered has-text-weight-bold">
                  {{ $translate('sottopiede') | uppercase }}
                </h3>
              </td>
              <td />
            </tr>
            <tr>
              <td />
              <td>
                <hr class="green" />
              </td>
              <td />
            </tr>
            <!--            <tr>
              <td class="has-text-centered">
                <b-field :type="{ 'is-danger': errors.has('tiposott_sx') }" :message="errors.first('tiposott_sx')">
                  <b-select
                    v-model="order['tiposott_sx']"
                    v-validate="{ required: order.deliverySelected != 'onlytom' }"
                    :disabled="order.pair === 'right' || disabledbool"
                    :name="'tiposott_sx'"
                    :placeholder="$translate('placeholder_select')"
                    @input="order['tiposott_var_sx'] = null"
                  >
                    <option v-for="variant in availablesott" :key="variant.id + '_sx'" :value="variant.id">
                      {{ $translateMaterial(variant) }}
                    </option>
                  </b-select>
                </b-field>
              </td>
              <td class="has-text-centered">
                {{ $translate('matsotto') | capitalize }}
              </td>
              <td class="has-text-centered">
                <b-field :type="{ 'is-danger': errors.has('tiposott_dx') }" :message="errors.first('tiposott_dx')">
                  <b-select
                    v-model="order['tiposott_dx']"
                    v-validate="{ required: order.deliverySelected != 'onlytom' }"
                    :disabled="order.pair === 'left' || disabledbool"
                    :name="'tiposott_dx'"
                    :placeholder="$translate('placeholder_select')"
                    @input="order['tiposott_var_dx'] = null"
                  >
                    <option v-for="variant in availablesott" :key="variant.id + '_dx'" :value="variant.id">
                      {{ $translateMaterial(variant) }}
                    </option>
                  </b-select>
                </b-field>
              </td>
            </tr>-->
            <!--            <tr>
              <td
                v-if="
                  order['tiposott_sx'] &&
                    availablesott.find(temp => temp.id === order['tiposott_sx']) &&
                    availablesott.find(temp => temp.id === order['tiposott_sx']).variants
                "
                class="has-text-centered"
              >
                <b-field
                  :type="{ 'is-danger': errors.has('tiposott_var_sx') }"
                  :message="errors.first('tiposott_var_sx')"
                >
                  <b-select
                    v-model="order['tiposott_var_sx']"
                    v-validate="{ required: order.deliverySelected != 'onlytom' }"
                    :disabled="order.pair === 'right' || disabledbool"
                    :name="'tiposott_var_sx'"
                    :placeholder="$translate('placeholder_select')"
                  >
                    <option
                      v-for="variant in availablesott.find(temp => temp.id === order['tiposott_sx']).variants"
                      :key="variant.id"
                      :value="variant.id"
                    >
                      {{ $translateMaterialVariant(variant) }}
                    </option>
                  </b-select>
                </b-field>
              </td>
              <td v-else-if="order['tiposott_dx']" class="has-text-centered" />
              <td v-if="order['tiposott_sx'] || order['tiposott_dx']" class="has-text-centered">
                {{ $translate('variant') | capitalize }}
              </td>
              <td
                v-if="
                  order['tiposott_dx'] &&
                    availablesott.find(temp => temp.id === order['tiposott_dx']) &&
                    availablesott.find(temp => temp.id === order['tiposott_dx']).variants
                "
                class="has-text-centered"
              >
                <b-field
                  :type="{ 'is-danger': errors.has('tiposott_var_dx') }"
                  :message="errors.first('tiposott_var_dx')"
                >
                  <b-select
                    v-model="order['tiposott_var_dx']"
                    v-validate="{ required: order.deliverySelected != 'onlytom' }"
                    :disabled="order.pair === 'left' || disabledbool"
                    :name="'tiposott_var_dx'"
                    :placeholder="$translate('placeholder_select')"
                  >
                    <option
                      v-for="variant in availablesott.find(temp => temp.id === order['tiposott_dx']).variants"
                      :key="variant.id"
                      :value="variant.id"
                    >
                      {{ $translateMaterialVariant(variant) }}
                    </option>
                  </b-select>
                </b-field>
              </td>
            </tr>-->
            <tr>
              <td class="has-text-centered">
                <b-select
                  v-model="order['tiporinfsott_sx']"
                  :disabled="disabledbool || order.module === 'modular'"
                  :name="'tiporinfsott_sx'"
                  :placeholder="$translate('placeholder_select')"
                >
                  <option value="sottopiede3">
                    {{ $translate('sottopiede3') }}
                  </option>
                  <option value="sottopiede4">
                    {{ $translate('sottopiede4') }}
                  </option>
                </b-select>
              </td>
              <td class="has-text-centered">
                {{ $translate('typesott') }}
              </td>
              <td class="has-text-centered">
                <b-select
                  v-model="order['tiporinfsott_dx']"
                  :disabled="disabledbool || order.module === 'modular'"
                  :name="'tiporinfsott_dx'"
                  :placeholder="$translate('placeholder_select')"
                >
                  <option value="sottopiede3">
                    {{ $translate('sottopiede3') }}
                  </option>
                  <option value="sottopiede4">
                    {{ $translate('sottopiede4') }}
                  </option>
                </b-select>
              </td>
            </tr>
            <tr>
              <td colspan="3"><hr /></td>
            </tr>
            <template v-if="order.module === 'fits'">
              <tr>
                <td class="has-text-centered">
                  <b-field
                    :type="{ 'is-danger': errors.has('rocker_sole_sx') }"
                    :message="errors.first('rocker_sole_sx')"
                  >
                    <!-- required:true is a trick of veevalidate to work with the pseudocheckbox-->
                    <b-checkbox
                      v-model="hasRockerSoleSx"
                      v-validate="order.tiporinfsott_sx === 'sottopiede4' ? 'required:true' : ''"
                      :disabled="disabledbool"
                      :name="'rocker_sole_sx'"
                      @input="onRockerChange"
                    ></b-checkbox>
                  </b-field>
                </td>
                <td class="has-text-centered">
                  <strong>{{ $translate('rocker sole') | capitalize }}</strong>
                </td>
                <td class="has-text-centered">
                  <b-field
                    :type="{ 'is-danger': errors.has('rocker_sole_dx') }"
                    :message="errors.first('rocker_sole_dx')"
                  >
                    <!-- required:true is a trick of veevalidate to work with the pseudocheckbox-->
                    <b-checkbox
                      v-model="hasRockerSoleDx"
                      v-validate="order.tiporinfsott_dx === 'sottopiede4' ? 'required:true' : ''"
                      :disabled="disabledbool"
                      :name="'rocker_sole_dx'"
                      @input="onRockerChange"
                    >
                    </b-checkbox>
                  </b-field>
                </td>
              </tr>
              <tr>
                <td colspan="3"></td>
              </tr>
              <tr>
                <td>
                  <b-field
                    v-if="hasRockerSoleSx || order['tiporinfsott_sx'] === 'sottopiede4'"
                    :type="{ 'is-danger': errors.has('rocker_heel_height_sx') }"
                    :message="errors.first('rocker_heel_height_sx')"
                  >
                    <b-input
                      v-validate="'between:0,15|integer'"
                      type="number"
                      name="rocker_heel_height_sx"
                      :disabled="disabledbool"
                      :placeholder="$translate('placeholder_numeric_mm')"
                      :value="values.left.rockerSole.heel_height"
                      @input="newVal => onChange(newVal, 'left', 'heel_height', 'rockerSole')"
                    >
                    </b-input>
                  </b-field>
                </td>
                <td class="header">
                  {{ $translate('heel_height') | capitalize }}
                </td>
                <td>
                  <b-field
                    v-if="hasRockerSoleDx || order['tiporinfsott_dx'] === 'sottopiede4'"
                    :type="{ 'is-danger': errors.has('rocker_heel_height_dx') }"
                    :message="errors.first('rocker_heel_height_dx')"
                  >
                    <!--                  v-validate="'delta_5:right,heel_height,fings_height,rockerSole'"-->
                    <b-input
                      v-validate="'between:0,15|integer'"
                      type="number"
                      name="rocker_heel_height_dx"
                      :disabled="disabledbool"
                      :value="values.right.rockerSole.heel_height"
                      :placeholder="$translate('placeholder_numeric_mm')"
                      @input="newVal => onChange(newVal, 'right', 'heel_height', 'rockerSole')"
                    >
                    </b-input>
                  </b-field>
                </td>
              </tr>
              <tr>
                <td>
                  <b-field
                    v-if="hasRockerSoleSx || order['tiporinfsott_sx'] === 'sottopiede4'"
                    :type="{ 'is-danger': errors.has('rocker_ball_height_sx') }"
                    :message="errors.first('rocker_ball_height_sx')"
                  >
                    <!--                  v-validate="'delta_5:left,ball_height,fings_height,rockerSole'"-->
                    <b-input
                      v-validate="'between:0,15|integer'"
                      type="number"
                      name="rocker_ball_height_sx"
                      :disabled="disabledbool"
                      :value="values.left.rockerSole.ball_height"
                      :placeholder="$translate('placeholder_numeric_mm')"
                      @input="newVal => onChange(newVal, 'left', 'ball_height', 'rockerSole')"
                    >
                    </b-input>
                  </b-field>
                </td>
                <td class="header">
                  {{ $translate('ball_height') | capitalize }}
                </td>
                <td>
                  <b-field
                    v-if="hasRockerSoleDx || order['tiporinfsott_dx'] === 'sottopiede4'"
                    :type="{ 'is-danger': errors.has('rocker_ball_height_dx') }"
                    :message="errors.first('rocker_ball_height_dx')"
                  >
                    <!--                  v-validate="'delta_5:right,ball_height,fings_height,rockerSole'"-->
                    <b-input
                      v-validate="'between:0,15|integer'"
                      type="number"
                      name="rocker_ball_height_dx"
                      :disabled="disabledbool"
                      :value="values.right.rockerSole.ball_height"
                      :placeholder="$translate('placeholder_numeric_mm')"
                      @input="newVal => onChange(newVal, 'right', 'ball_height', 'rockerSole')"
                    >
                    </b-input>
                  </b-field>
                </td>
              </tr>
              <tr>
                <td>
                  <b-field
                    v-if="hasRockerSoleSx || order['tiporinfsott_sx'] === 'sottopiede4'"
                    :type="{ 'is-danger': errors.has('rocker_fings_height_sx') }"
                    :message="errors.first('rocker_fings_height_sx')"
                  >
                    <!--                  v-validate="
                  'delta_5:left,heel_height,fings_height,rockerSole|delta_5:left,ball_height,fings_height,rockerSole'
                  "-->
                    <b-input
                      v-validate="'between:0,15|integer'"
                      type="number"
                      name="rocker_fings_height_sx"
                      :disabled="disabledbool"
                      :value="values.left.rockerSole.fings_height"
                      :placeholder="$translate('placeholder_numeric_mm')"
                      @input="newVal => onChange(newVal, 'left', 'fings_height', 'rockerSole')"
                    >
                    </b-input>
                  </b-field>
                </td>
                <td class="header">
                  {{ $translate('fings_height') | capitalize }}
                </td>
                <td>
                  <b-field
                    v-if="hasRockerSoleDx || order['tiporinfsott_dx'] === 'sottopiede4'"
                    :type="{ 'is-danger': errors.has('rocker_fings_height_dx') }"
                    :message="errors.first('rocker_fings_height_dx')"
                  >
                    <!--                  v-validate="'delta_5:right,heel_height,fings_height,rockerSole'"-->
                    <b-input
                      v-validate="'between:0,15|integer'"
                      type="number"
                      name="rocker_fings_height_dx"
                      :disabled="disabledbool"
                      :value="values.right.rockerSole.fings_height"
                      :placeholder="$translate('placeholder_numeric_mm')"
                      @input="newVal => onChange(newVal, 'right', 'fings_height', 'rockerSole')"
                    >
                    </b-input>
                  </b-field>
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  <hr />
                </td>
              </tr>
            </template>
            <template v-if="(order.mod.sole && order.mod.sole.hasRialzi) || order.module === 'fits'">
              <tr>
                <td colspan="3" class="has-text-centered">
                  <strong>{{ $translate('ext_rise') | capitalize }}</strong>
                </td>
              </tr>
              <tr>
                <td>
                  <b-field :type="{ 'is-danger': errors.has('heel_rise_sx') }" :message="errors.first('heel_rise_sx')">
                    <b-input
                      v-validate="'between:0,40|integer'"
                      type="number"
                      name="heel_rise_sx"
                      :disabled="disabledbool"
                      :value="values.left.extRise.heel_rise"
                      :placeholder="$translate('placeholder_numeric_mm')"
                      @input="newVal => onChange(newVal, 'left', 'heel_rise', 'extRise')"
                    >
                    </b-input>
                  </b-field>
                </td>
                <td class="header">
                  {{ $translate('heel_rise') | capitalize }}
                </td>
                <td>
                  <b-field :type="{ 'is-danger': errors.has('heel_rise_dx') }" :message="errors.first('heel_rise_dx')">
                    <b-input
                      v-validate="'between:0,40|integer'"
                      type="number"
                      name="heel_rise_dx"
                      :disabled="disabledbool"
                      :value="values.right.extRise.heel_rise"
                      :placeholder="$translate('placeholder_numeric_mm')"
                      @input="newVal => onChange(newVal, 'right', 'heel_rise', 'extRise')"
                    >
                    </b-input>
                  </b-field>
                </td>
              </tr>
              <tr>
                <td>
                  <b-field :type="{ 'is-danger': errors.has('ball_rise_sx') }" :message="errors.first('ball_rise_sx')">
                    <b-input
                      v-validate="'between:0,40|integer'"
                      type="number"
                      name="ball_rise_sx"
                      :disabled="disabledbool"
                      :value="values.left.extRise.ball_rise"
                      :placeholder="$translate('placeholder_numeric_mm')"
                      @input="newVal => onChange(newVal, 'left', 'ball_rise', 'extRise')"
                    >
                    </b-input>
                  </b-field>
                </td>
                <td class="header">
                  {{ $translate('ball_rise') | capitalize }}
                </td>
                <td>
                  <b-field :type="{ 'is-danger': errors.has('ball_rise_dx') }" :message="errors.first('ball_rise_dx')">
                    <b-input
                      v-validate="'between:0,40|integer'"
                      type="number"
                      name="ball_rise_dx"
                      :disabled="disabledbool"
                      :value="values.right.extRise.ball_rise"
                      :placeholder="$translate('placeholder_numeric_mm')"
                      @input="newVal => onChange(newVal, 'right', 'ball_rise', 'extRise')"
                    >
                    </b-input>
                  </b-field>
                </td>
              </tr>
              <tr>
                <td>
                  <b-field :type="{ 'is-danger': errors.has('fings_rise') }" :message="errors.first('fings_rise')">
                    <b-input
                      v-validate="'between:0,40|integer'"
                      type="number"
                      name="fings_rise"
                      :disabled="disabledbool"
                      :value="values.left.extRise.fings_rise"
                      :placeholder="$translate('placeholder_numeric_mm')"
                      @input="newVal => onChange(newVal, 'left', 'fings_rise', 'extRise')"
                    >
                    </b-input>
                  </b-field>
                </td>
                <td class="header">
                  {{ $translate('fings_rise') | capitalize }}
                </td>
                <td>
                  <b-field :type="{ 'is-danger': errors.has('fings_rise') }" :message="errors.first('fings_rise')">
                    <b-input
                      v-validate="'between:0,40|integer'"
                      type="number"
                      name="fings_rise"
                      :disabled="disabledbool"
                      :value="values.right.extRise.fings_rise"
                      :placeholder="$translate('placeholder_numeric_mm')"
                      @input="newVal => onChange(newVal, 'right', 'fings_rise', 'extRise')"
                    >
                    </b-input>
                  </b-field>
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  <hr />
                </td>
              </tr>
            </template>
            <template v-if="(order.mod.sole && order.mod.sole.hasCampanatura) || order.module === 'fits'">
              <tr>
                <td colspan="3" class="has-text-centered">
                  <strong>{{ $translate('camber') | capitalize }}</strong>
                </td>
              </tr>
              <tr>
                <td>
                  <b-field :type="{ 'is-danger': errors.has('medial_sx') }" :message="errors.first('medial_sx')">
                    <b-input
                      v-validate="'between:0,10|integer'"
                      type="number"
                      name="medial_sx"
                      :disabled="disabledbool"
                      :value="values.left.camber.medial"
                      :placeholder="$translate('placeholder_numeric_mm')"
                      @input="newVal => onChange(newVal, 'left', 'medial', 'camber')"
                    >
                    </b-input>
                  </b-field>
                </td>
                <td class="header">
                  {{ $translate('medial_camber') | capitalize }}
                </td>
                <td>
                  <b-field :type="{ 'is-danger': errors.has('medial_dx') }" :message="errors.first('medial_dx')">
                    <b-input
                      v-validate="'between:0,10|integer'"
                      type="number"
                      name="medial_dx"
                      :disabled="disabledbool"
                      :value="values.right.camber.medial"
                      :placeholder="$translate('placeholder_numeric_mm')"
                      @input="newVal => onChange(newVal, 'right', 'medial', 'camber')"
                    >
                    </b-input>
                  </b-field>
                </td>
              </tr>
              <tr>
                <td>
                  <b-field :type="{ 'is-danger': errors.has('side_sx') }" :message="errors.first('side_sx')">
                    <b-input
                      v-validate="'between:0,10|integer'"
                      type="number"
                      name="side_sx"
                      :disabled="disabledbool"
                      :value="values.left.camber.side"
                      :placeholder="$translate('placeholder_numeric_mm')"
                      @input="newVal => onChange(newVal, 'left', 'side', 'camber')"
                    >
                    </b-input>
                  </b-field>
                </td>
                <td class="header">
                  {{ $translate('side_camber') | capitalize }}
                </td>
                <td>
                  <b-field :type="{ 'is-danger': errors.has('side_dx') }" :message="errors.first('side_dx')">
                    <b-input
                      v-validate="'between:0,10|integer'"
                      type="number"
                      name="side_dx"
                      :disabled="disabledbool"
                      :value="values.right.camber.side"
                      :placeholder="$translate('placeholder_numeric_mm')"
                      @input="newVal => onChange(newVal, 'right', 'side', 'camber')"
                    >
                    </b-input>
                  </b-field>
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  <hr />
                </td>
              </tr>
            </template>
            <template v-if="(order.mod.sole && order.mod.sole.hasSperonatura) || order.module === 'fits'">
              <tr>
                <td colspan="3" class="has-text-centered">
                  <strong>{{ $translate('speronatura') | capitalize }}</strong>
                </td>
              </tr>
              <tr>
                <td>
                  <b-field
                    :type="{ 'is-danger': errors.has('medial_heel_sx') }"
                    :message="errors.first('medial_heel_sx')"
                  >
                    <b-input
                      v-validate="'between:0,10|integer'"
                      type="number"
                      name="medial_heel_sx"
                      :disabled="disabledbool"
                      :value="values.left.speronatura.medial_heel"
                      :placeholder="$translate('placeholder_numeric_mm')"
                      @input="newVal => onChange(newVal, 'left', 'medial_heel', 'speronatura')"
                    >
                    </b-input>
                  </b-field>
                </td>
                <td class="header">
                  {{ $translate('spe_medial_heel') | capitalize }}
                </td>
                <td>
                  <b-field
                    :type="{ 'is-danger': errors.has('medial_heel_dx') }"
                    :message="errors.first('medial_heel_dx')"
                  >
                    <b-input
                      v-validate="'between:0,10|integer'"
                      type="number"
                      name="medial_heel_dx"
                      :disabled="disabledbool"
                      :value="values.right.speronatura.medial_heel"
                      :placeholder="$translate('placeholder_numeric_mm')"
                      @input="newVal => onChange(newVal, 'right', 'medial_heel', 'speronatura')"
                    >
                    </b-input>
                  </b-field>
                </td>
              </tr>
              <tr>
                <td>
                  <b-field :type="{ 'is-danger': errors.has('side_heel_sx') }" :message="errors.first('side_heel_sx')">
                    <b-input
                      v-validate="'between:0,10|integer'"
                      type="number"
                      name="side_heel_sx"
                      :disabled="disabledbool"
                      :value="values.left.speronatura.side_heel"
                      :placeholder="$translate('placeholder_numeric_mm')"
                      @input="newVal => onChange(newVal, 'left', 'side_heel', 'speronatura')"
                    >
                    </b-input>
                  </b-field>
                </td>
                <td class="header">
                  {{ $translate('spe_side_heel') | capitalize }}
                </td>
                <td>
                  <b-field :type="{ 'is-danger': errors.has('side_heel_dx') }" :message="errors.first('side_heel_dx')">
                    <b-input
                      v-validate="'between:0,10|integer'"
                      type="number"
                      name="side_heel_dx"
                      :disabled="disabledbool"
                      :value="values.right.speronatura.side_heel"
                      :placeholder="$translate('placeholder_numeric_mm')"
                      @input="newVal => onChange(newVal, 'right', 'side_heel', 'speronatura')"
                    >
                    </b-input>
                  </b-field>
                </td>
              </tr>
              <tr>
                <td>
                  <b-field :type="{ 'is-danger': errors.has('medial_plant') }" :message="errors.first('medial_plant')">
                    <b-input
                      v-validate="'between:0,10|integer'"
                      type="number"
                      name="medial_plant"
                      :disabled="disabledbool"
                      :value="values.left.speronatura.medial_plant"
                      :placeholder="$translate('placeholder_numeric_mm')"
                      @input="newVal => onChange(newVal, 'left', 'medial_plant', 'speronatura')"
                    >
                    </b-input>
                  </b-field>
                </td>
                <td class="header">
                  {{ $translate('spe_medial_plant') | capitalize }}
                </td>
                <td>
                  <b-field :type="{ 'is-danger': errors.has('medial_plant') }" :message="errors.first('medial_plant')">
                    <b-input
                      v-validate="'between:0,10|integer'"
                      type="number"
                      name="medial_plant"
                      :disabled="disabledbool"
                      :value="values.right.speronatura.medial_plant"
                      :placeholder="$translate('placeholder_numeric_mm')"
                      @input="newVal => onChange(newVal, 'right', 'medial_plant', 'speronatura')"
                    >
                    </b-input>
                  </b-field>
                </td>
              </tr>
              <tr>
                <td>
                  <b-field
                    :type="{ 'is-danger': errors.has('side_plant_sx') }"
                    :message="errors.first('side_plant_sx')"
                  >
                    <b-input
                      v-validate="'between:0,10|integer'"
                      type="number"
                      name="side_plant_sx"
                      :disabled="disabledbool"
                      :value="values.left.speronatura.side_plant"
                      :placeholder="$translate('placeholder_numeric_mm')"
                      @input="newVal => onChange(newVal, 'left', 'side_plant', 'speronatura')"
                    >
                    </b-input>
                  </b-field>
                </td>
                <td class="header">
                  {{ $translate('spe_side_plant') | capitalize }}
                </td>
                <td>
                  <b-field
                    :type="{ 'is-danger': errors.has('side_plant_dx') }"
                    :message="errors.first('side_plant_dx')"
                  >
                    <b-input
                      v-validate="'between:0,10|integer'"
                      type="number"
                      name="side_plant_dx"
                      :disabled="disabledbool"
                      :value="values.right.speronatura.side_plant"
                      :placeholder="$translate('placeholder_numeric_mm')"
                      @input="newVal => onChange(newVal, 'right', 'side_plant', 'speronatura')"
                    >
                    </b-input>
                  </b-field>
                </td>
              </tr>
            </template>
          </table>
        </div>
        <div class="column" />
      </div>
    </div>
    <!-- Sezione sottopiede -->

    <template v-if="order.module === 'modular'">
      <hr class="green" />
      <b-field custom-class="green" :label="$translate('note') | capitalize">
        <b-input v-model="order.note" type="textarea" name="note" :disabled="disabledbool" />
      </b-field>
    </template>
  </div>
</template>

<script>
import '../../../helpers/mixins/variables/prod_details'

export default {
  name: 'ProdDetails',
  props: ['order', 'disabledbool', 'availablecont', 'availablesott', 'sole', 'details'],
  inject: ['$validator'],
  data() {
    return {
      contrMatVarVisible: false,
      contrMatVars: [],
      hasRockerSoleSx: false,
      hasRockerSoleDx: false,
      values: {
        left: { rockerSole: {}, extRise: {}, camber: {}, speronatura: {} },
        right: { rockerSole: {}, extRise: {}, camber: {}, speronatura: {} },
      },
    }
  },
  computed: {
    config() {
      return this.$moduleConfiguration[this.order.module]
    },
    contrSxPreview() {
      switch (this.order.typecontr_sx) {
        case 'calc':
          return require('@/assets/images/contrafforti/calcaneare_sx.png')
        case 'short':
          return require('@/assets/images/contrafforti/corto_sx.png')
        case 'pro_med':
          return require('@/assets/images/contrafforti/prolungato_mediale_sx.png')
        case 'pro_lat':
          return require('@/assets/images/contrafforti/prolungato_laterale_sx.png')
        case 'semi_bi':
          return require('@/assets/images/contrafforti/semirigido_sx.png')
        case 'medial':
          return require('@/assets/images/contrafforti/mediale_sx.png')
        case 'sidal':
          return require('@/assets/images/contrafforti/laterale_sx.png')
        case 'rig_bi':
          return require('@/assets/images/contrafforti/bilaterale_sx.png')
        case 'peronoic':
          return require('@/assets/images/contrafforti/peroneo_sx.png')
        case 'pro_bi':
          return require('@/assets/images/contrafforti/prolungato_bilaterale_sx.png')
        case 'high_bi':
          return require('@/assets/images/contrafforti/alto_bilaterale_sx.png')
        case 'total':
          return require('@/assets/images/contrafforti/completo_sx.png')
        default:
          return 'https://via.placeholder.com/300'
      }
    },
    contrDxPreview() {
      switch (this.order.typecontr_dx) {
        case 'calc':
          return require('@/assets/images/contrafforti/calcaneare_dx.png')
        case 'short':
          return require('@/assets/images/contrafforti/corto_dx.png')
        case 'pro_med':
          return require('@/assets/images/contrafforti/prolungato_mediale_dx.png')
        case 'pro_lat':
          return require('@/assets/images/contrafforti/prolungato_laterale_dx.png')
        case 'semi_bi':
          return require('@/assets/images/contrafforti/semirigido_dx.png')
        case 'medial':
          return require('@/assets/images/contrafforti/mediale_dx.png')
        case 'sidal':
          return require('@/assets/images/contrafforti/laterale_dx.png')
        case 'rig_bi':
          return require('@/assets/images/contrafforti/bilaterale_dx.png')
        case 'peronoic':
          return require('@/assets/images/contrafforti/peroneo_dx.png')
        case 'pro_bi':
          return require('@/assets/images/contrafforti/prolungato_bilaterale_dx.png')
        case 'high_bi':
          return require('@/assets/images/contrafforti/alto_bilaterale_dx.png')
        case 'total':
          return require('@/assets/images/contrafforti/completo_dx.png')
        default:
          return 'https://via.placeholder.com/300'
      }
    },
    // contrType() {
    //   const types = ['Noone', 'calc', 'short', 'pro_med', 'pro_lat', 'pro_bi']
    //   const highTypes = ['high_bi', 'medial', 'sidal', 'total', 'peronoic']
    //   return this.order.shoeType === 'high' ? [...types, ...highTypes] : types
    // },
  },
  watch: {
    details: {
      handler(newValues) {
        this.values = { ...this.values, ...newValues }
        if (Object.keys(this.values.left.rockerSole).length > 0) {
          this.hasRockerSoleSx = true
        }
        if (Object.keys(this.values.right.rockerSole).length > 0) {
          this.hasRockerSoleDx = true
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.values = { ...this.values, ...this.order.prod_details }
  },
  methods: {
    onChange(newValue, foot, header, identifier) {
      this.values[foot][identifier] = { ...this.values[foot][identifier], [header]: newValue }
      this.$emit('update', this.values)
    },
    copyToOtherFoot(foot, isReinforce = false) {
      if (foot === 'left') {
        this.values.right = { ...this.values.left }
        if (isReinforce === true) {
          this.order.tiporinfsott_dx = this.order.tiporinfsott_sx
          this.hasRockerSoleDx = this.hasRockerSoleSx
        }
      }
      if (foot === 'right') {
        this.values.left = { ...this.values.right }
        if (isReinforce === true) {
          this.order.tiporinfsott_sx = this.order.tiporinfsott_dx
          this.hasRockerSoleSx = this.hasRockerSoleDx
        }
      }
      this.$emit('update', this.values)
    },
    onRockerChange() {
      if (!this.hasRockerSoleSx) {
        this.values.left.rockerSole = {}
      }
      if (!this.hasRockerSoleDx) {
        this.values.right.rockerSole = {}
      }
    },
    /*    checkHasRockerSole(foot) {
      if (foot === 'left' && this.order['tiporinfsott_sx'] === 'sottopiede4') {
        this.hasRockerSoleSx = true
      }
      if (foot === 'right' && this.order['tiporinfsott_dx'] === 'sottopiede4') {
        this.hasRockerSoleDx = true
      }
    },*/
    changeContrMaterialSx() {
      this.contrMatVarVisible = this.order['typecontr_sx'] && this.order['typecontr_sx' !== 'Noone']
      this.contrMatVars = this.availablecont.find(m => m.id === this.order['tipocontr_sx']).variants
      this.order['tipocontr_var_sx'] = this.contrMatVars.length === 1 ? this.contrMatVars[0] : null
      //console.log(this.contrMatVarVisible)
      //console.log(this.contrMatVars)
      //console.log(this.order['tipocontr_var_sx'])
    },
    copypasdxinsx() {
      if (this.order.typecontr_dx !== undefined) {
        this.order.typecontr_sx = this.order.typecontr_dx
      }
      if (this.order.tiporinfcontr_dx !== undefined) {
        this.order.tiporinfcontr_sx = this.order.tiporinfcontr_dx
      }
      if (this.order.tipocontr_dx !== undefined) {
        this.order.tipocontr_sx = this.order.tipocontr_dx
      }
      if (this.order.tipocontr_var_dx !== undefined) {
        this.order.tipocontr_var_sx = this.order.tipocontr_var_dx
      }
      if (this.order.matrinfcontr_dx !== undefined) {
        this.order.matrinfcontr_sx = this.order.matrinfcontr_dx
      }
      if (this.order.matrinfcontr_var_dx !== undefined) {
        this.order.matrinfcontr_var_sx = this.order.matrinfcontr_var_dx
      }
      this.$forceUpdate()
    },
    copypassxindx() {
      if (this.order.typecontr_sx !== undefined) {
        this.order.typecontr_dx = this.order.typecontr_sx
      }
      if (this.order.tiporinfcontr_sx !== undefined) {
        this.order.tiporinfcontr_dx = this.order.tiporinfcontr_sx
      }
      if (this.order.tipocontr_sx !== undefined) {
        this.order.tipocontr_dx = this.order.tipocontr_sx
      }
      if (this.order.tipocontr_var_sx !== undefined) {
        this.order.tipocontr_var_dx = this.order.tipocontr_var_sx
      }
      if (this.order.matrinfcontr_sx !== undefined) {
        this.order.matrinfcontr_dx = this.order.matrinfcontr_sx
      }
      if (this.order.matrinfcontr_var_sx !== undefined) {
        this.order.matrinfcontr_var_dx = this.order.matrinfcontr_var_sx
      }
      this.$forceUpdate()
    },
    copysottopiededxinsx() {
      if (this.order.tiporinfsott_dx != undefined) {
        this.order.tiporinfsott_sx = this.order.tiporinfsott_dx
      }
      if (this.order.tiposott_dx != undefined) {
        this.order.tiposott_sx = this.order.tiposott_dx
      }
      if (this.order.tiposott_var_dx != undefined) {
        this.order.tiposott_var_sx = this.order.tiposott_var_dx
      }
      if (this.order.footmeasurements.thick_plant_dx != undefined) {
        this.order.footmeasurements.thick_plant_sx = this.order.footmeasurements.thick_plant_dx
      }
      if (this.order.footmeasurements.thick_tacc_dx != undefined) {
        this.order.footmeasurements.thick_tacc_sx = this.order.footmeasurements.thick_tacc_dx
      }
      this.$forceUpdate()
    },
    copysottopiedesxindx() {
      if (this.order.tiporinfsott_sx != undefined) {
        this.order.tiporinfsott_dx = this.order.tiporinfsott_sx
      }
      if (this.order.tiposott_sx != undefined) {
        this.order.tiposott_dx = this.order.tiposott_sx
      }
      if (this.order.tiposott_var_sx != undefined) {
        this.order.tiposott_var_dx = this.order.tiposott_var_sx
      }
      if (this.order.footmeasurements.thick_plant_sx != undefined) {
        this.order.footmeasurements.thick_plant_dx = this.order.footmeasurements.thick_plant_sx
      }
      if (this.order.footmeasurements.thick_tacc_sx != undefined) {
        this.order.footmeasurements.thick_tacc_dx = this.order.footmeasurements.thick_tacc_sx
      }
      this.$forceUpdate()
    },
  },
}
</script>
<style scoped>
.container >>> td input {
  text-align: center;
}
.container >>> th input {
  text-align: center;
}
.preview {
  max-height: 300px;
  max-width: 300px;
  width: 300px;
}
</style>
